import React from 'react';
import styled from 'styled-components';
import { Row, Col, Card, Grid } from 'antd';
import { useIntl } from 'react-intl';
import withLoading from 'Common/HOC/loadingOr';

const { useBreakpoint } = Grid;

const ReportCard = styled(Card)`
  width: 100%;
  .label {
    text-transform: uppercase;
    color: rgba(0, 0, 0, 0.45);
  }
  .value {
    font-size: 24px;
    font-weight: 50px;
    color: rgba(0, 0, 0, 0.85);
  }
`;

const renderCard = (
  label: string,
  value: string,
  style?: React.CSSProperties
) => (
  <Col flex="1 1 0" md={8} key={label} style={style}>
    <ReportCard styles={{ body: { padding: '12px 18px' } }}>
      <span className="label">{label}</span>
      <br />
      <span className="value">{value}</span>
    </ReportCard>
  </Col>
);

interface Props {
  currency: string;
  margin: number;
  totalRevenue: number;
  invoices: number;
  returns: number;
  soldProducts: number;
  avgBasketValue: number;
}

const RevenueOverviewCardsRow: React.FC<Props> = ({
  currency,
  margin,
  totalRevenue,
  invoices,
  returns,
  soldProducts,
  avgBasketValue,
}) => {
  const intl = useIntl();
  const screens = useBreakpoint();
  const cards = [
    {
      label: intl.formatMessage({ defaultMessage: 'Total revenue' }),
      value: intl.formatNumber(totalRevenue, { style: 'currency', currency }),
    },
    {
      label: intl.formatMessage({ defaultMessage: 'Margin' }),
      value: intl.formatNumber(margin, { style: 'currency', currency }),
    },

    {
      label: intl.formatMessage({ defaultMessage: 'Avg. Basket value' }),
      value: intl.formatNumber(avgBasketValue, { style: 'currency', currency }),
    },
    {
      label: intl.formatMessage({ defaultMessage: 'Sold products' }),
      value: intl.formatNumber(soldProducts),
    },
    {
      label: [
        intl.formatMessage({ defaultMessage: 'Invoices' }),
        intl.formatMessage({ defaultMessage: 'Returns' }),
      ].join(' / '),
      value: [intl.formatNumber(invoices), intl.formatNumber(returns)].join(
        ' / '
      ),
    },
  ];

  if (screens.xl) {
    return (
      <Row gutter={25}>
        {cards.map((card) => renderCard(card.label, card.value))}
      </Row>
    );
  }
  return (
    <>
      <Row gutter={25}>
        {cards.slice(0, 3).map((card) => renderCard(card.label, card.value))}
      </Row>
      <Row gutter={25}>
        {cards
          .slice(3, 5)
          .map((card) => renderCard(card.label, card.value, { marginTop: 15 }))}
      </Row>
    </>
  );
};

export default withLoading(RevenueOverviewCardsRow);
